module.exports = __webpack_public_path__ + "static/assets/cf65c9399ffb51dfa464d282e3779b93.png";